export function clear(): KeyboardState {
  return [];
}
